import { lazy } from 'react';
import { adaptiveWrapperOptions } from '../../appComponents/ModalWrapper';
import { wrapNavigatorScreen } from '../../functions/navigation/utils/wrapNavigatorScreen';

const MediaPreviewPageContent = lazy(() => import('./MediaPreviewPageContent'));

const MediaPreviewPage = wrapNavigatorScreen(
  MediaPreviewPageContent,
  adaptiveWrapperOptions(isMobile =>
    isMobile
      ? {
          presentation: undefined,
          headerTransparent: true,
          title: ' ',
        }
      : {},
  ),
);

export default MediaPreviewPage;
